import {useCallback, MouseEvent, useState, useEffect} from 'react';
import {changeUrlParam} from '@baidu/health-utils/lib/url/changeUrlParam';
import SvgIcon from '@/components/common/svgIcon';
import {useSearchParams} from '@/hooks/router';
import * as Logger from '@/utils/ubcUtils';
import styles from './appInvoke.less';

interface AppInvokeProps {
    logo: string;
    title: string;
    subtitle: string;
    buttonText: string;
    url: string;
}

function AppInvoke(props: AppInvokeProps) {
    const {
        logo,
        title,
        subtitle,
        buttonText,
        url,
    } = props;

    const [show, setShow] = useState(true);
    const query = useSearchParams();

    const handleClick = useCallback(
        (event: MouseEvent) => {
            event.stopPropagation();
            Logger.clk({
                page: 'vote_index',
                value: 'op_banner_clk',
                ext: {
                    // eslint-disable-next-line camelcase
                    sf_ref: query.channel,
                    id: query.id,
                    url: url,
                },
            });
            window.location.href = changeUrlParam(url, 'channelID', query?.channel);
        },
        [query, url]
    );

    const handleClose = useCallback(
        (e: MouseEvent) => {
            e.stopPropagation();
            setShow(false);
            Logger.clk({
                page: 'vote_index',
                value: 'op_banner_close',
                ext: {
                    // eslint-disable-next-line camelcase
                    sf_ref: query.channel,
                    id: query.id,
                    url: url,
                },
            });
        },
        [query.channel, query.id, url]
    );

    useEffect(
        () => {
            Logger.view({
                page: 'vote_index',
                value: 'op_banner_show',
                ext: {
                    // eslint-disable-next-line camelcase
                    sf_ref: query.channel,
                    id: query.id,
                    url: url,
                },
            });
        },
        [query.channel, query.id, url]
    );

    return (
        show
            ? (
                <div className={styles.appInvoke} onClick={handleClick}>
                    <div className={styles.inner}>
                        <div className={styles.appInfo}>
                            <img className={styles.logo} src={logo} />
                            <div>
                                <div className={styles.title}>{title}</div>
                                <div>{subtitle}</div>
                            </div>
                        </div>
                        <div className={styles.operation}>
                            <div className={styles.button}>{buttonText}</div>
                            <SvgIcon name="close" className={styles.close} onClick={handleClose} />
                        </div>
                    </div>
                </div>
            )
            : null
    );
}

export default AppInvoke;
